import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito ser extrovertido?',
  answer: 'No. Este sistema funciona con cualquier estilo de personalidad. No se trata de actuar ni de ser el alma de la fiesta, sino de usar una estructura que proyecte autoridad natural.'
}, {
  question: '¿Cuánto tarda en verse el resultado?',
  answer: 'Empiezas hoy, lo aplicas en tu siguiente conversación. Las técnicas como el Modelo 3S o el método 1-3-1 tienen un impacto inmediato en cómo te perciben.'
}, {
  question: '¿Sirve para videollamadas?',
  answer: 'Sí, absolutamente. Incluye pautas específicas para presencia en cámara, manejo de silencios y cierres claros en entornos virtuales.'
}, {
  question: '¿Y si no tengo tiempo?',
  answer: 'El ebook está diseñado para gente ocupada. Diez minutos de lectura y práctica son suficientes para empezar a usar una herramienta nueva ese mismo día.'
}, {
  question: '¿Qué formato tiene el contenido?',
  answer: 'Es 100% digital. Recibes el ebook en PDF, junto con las plantillas editables y hojas de trabajo para descargar y usar al instante.'
}, {
  question: '¿Cuándo recibo el acceso?',
  answer: 'Inmediatamente. En menos de 5 minutos después de tu compra tendrás un correo con todos los enlaces de descarga.'
}, {
  question: '¿Hay garantía?',
  answer: 'Sí. Tienes 30 días de garantía incondicional. Si sientes que el material no te aporta valor, te devolvemos el 100% de tu dinero sin preguntas.'
}, {
  question: '¿Es solo teoría?',
  answer: 'No. Es un manual táctico. Menos del 10% es teoría de contexto; el 90% restante son herramientas, scripts y estructuras para usar ya.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-[#F5F1E8]" data-id="element-49">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a3a52] mb-4" data-id="element-52">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto rounded-full" data-id="element-53" />
        </div>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-56">
                <span className="font-bold text-[#1a3a52] text-lg pr-8" data-id="element-57">
                  {faq.question}
                </span>
                <ChevronDown className={`text-[#C9A961] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-58" />
              </button>

              <AnimatePresence data-id="element-59">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-60">
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-61">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}